<mat-tab-group class="surface-tabs" [selectedIndex]="0" animationDuration="0ms">

  <!-- Training: first and default. -->
  <mat-tab label="Training">
    <app-training></app-training>
  </mat-tab>

  <!-- Setup -->
  <mat-tab label="Setup">
    <mat-card class="options-card">
      <mat-card-content>
        <div class="header-row">
          <div>
            <h3>Builder options</h3>
            <p class="hint">
              How <strong>{{ selectedCompany?.name || 'this company' }}</strong>'s homes are converted and shown.
              These are choices, not facts about your drawings.
            </p>
          </div>
          <div class="header-actions" *ngIf="options">
            <button mat-stroked-button (click)="revert()" [disabled]="saving || !isDirty"
                    matTooltip="Discard unsaved changes">
              <mat-icon>undo</mat-icon> Discard
            </button>
            <button mat-flat-button color="primary" (click)="save()"
                    [disabled]="saving || !isDirty" [class.button-spinner]="saving">
              <mat-icon>save</mat-icon> Save
            </button>
          </div>
        </div>

        <div *ngIf="loading" class="loading">
          <mat-spinner diameter="28"></mat-spinner>
        </div>

        <div *ngIf="!loading && loadError" class="load-error">
          <mat-icon color="warn">error_outline</mat-icon>
          <span>{{ loadError }}</span>
          <button mat-stroked-button (click)="loadData()">Retry</button>
        </div>

        <ng-container *ngIf="!loading && options">
          <ng-container *ngTemplateOutlet="groups; context: { $implicit: exportGroups }"></ng-container>

          <ng-container *ngIf="isSituUser">
            <div class="staff-divider">
              <span class="staff-note">Consumed while the warp module is generated; never reaches the viewer. Visible to Situ staff only.</span>
            </div>
            <ng-container *ngTemplateOutlet="groups; context: { $implicit: localGroups }"></ng-container>
          </ng-container>

          <div class="footer-actions">
            <button mat-flat-button color="primary" (click)="save()"
                    [disabled]="saving || !isDirty" [class.button-spinner]="saving">
              <mat-icon>save</mat-icon> Save
            </button>
            <span class="hint">Homes converted from now on use the saved options.</span>
          </div>

          <div class="reset-row">
            <button mat-button (click)="resetToDefaults()" [disabled]="saving">
              <mat-icon>restart_alt</mat-icon> Reset all options to defaults
            </button>
            <span class="hint">Nothing is saved until you press Save.</span>
          </div>
        </ng-container>
      </mat-card-content>
    </mat-card>
  </mat-tab>

</mat-tab-group>

<ng-template #groups let-groupList>
  <section class="option-group" *ngFor="let group of groupList">
    <h4>{{ group.title }}</h4>

    <div class="option-row" *ngFor="let row of group.rows" [class.dependent]="row.dependsOn" [class.depth-2]="depth(row) > 1" [class.unavailable]="!isEnabled(row)">
      <div class="option-label">
        <span>{{ row.label }}</span>
        <small *ngIf="row.help">{{ row.help }}</small>
      </div>

      <div class="option-control" [ngSwitch]="row.kind">
        <mat-slide-toggle *ngSwitchCase="'toggle'" color="primary"
                          [checked]="getToggle(row)"
                          (change)="setToggle(row, $event.checked)"
                          [disabled]="saving || !isEnabled(row)">
        </mat-slide-toggle>

        <mat-form-field *ngSwitchCase="'select'" appearance="outline" class="select-field">
          <mat-select [value]="getValue(row)" (selectionChange)="setValue(row, $event.value)" [disabled]="saving || !isEnabled(row)">
            <mat-option *ngFor="let choice of row.choices" [value]="choice.value">{{ choice.label }}</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field *ngSwitchCase="'number'" appearance="outline" class="number-field">
          <input matInput type="number"
                 [ngModel]="getNumber(row)"
                 (ngModelChange)="setNumber(row, $event)"
                 [step]="row.step ?? 1"
                 [min]="row.min ?? null"
                 [max]="row.max ?? null"
                 [disabled]="saving || !isEnabled(row)">
          <span matSuffix *ngIf="row.unit">{{ row.unit }}</span>
        </mat-form-field>
      </div>
    </div>
  </section>
</ng-template>
